import * as React from 'react';
import { usePlannerTranslations } from '../../Planner/Context/PlannerTranslationsContextProvider';
import { Button } from '~/Partials/Button/Button';
import { ButtonSize } from '~/Partials/Button/ButtonSize.csharp';
import { ButtonTier } from '~/Partials/Button/ButtonTier.csharp';
import { ButtonType } from '~/Partials/Button/ButtonType.csharp';
import { SvgIcon } from '~/Partials/SvgIcon/SvgIcon';
import styles from './SummaryHeader.module.css';

export interface SummaryHeaderProps {
    heading: string;
    onCollapseClick: () => void;
}

export const SummaryHeader: React.FC<SummaryHeaderProps> = props => {
    const { heading, onCollapseClick } = props;
    const { actions } = usePlannerTranslations();
    const { hideContent } = actions;

    return (
        <div className={styles.SummaryHeader}>
            <h4 className={styles.Heading}>{heading}</h4>
            <Button
                className={styles.Button}
                type={ButtonType.Solid}
                tier={ButtonTier.Tertiary}
                size={ButtonSize.Medium}
                onClick={onCollapseClick}
            >
                <span className="visuallyHidden">{hideContent}</span>
                <SvgIcon className={styles.ButtonIcon} iconName="arrow" />
            </Button>
        </div>
    );
};
